import { useState } from "react";
import { Card } from "@/types";
import { useDateFormatter, useTranslations } from "@/contexts/Translation";
import { getCardUrl } from "@/lib/getCardUrl";
import JourneyCard from "../JourneyCard/JourneyCard";
import ScreenshotView from "../JourneyCard/ScreenshotView";
import Modal from "../Modal/Modal";
import Clouds from "../Decor/Clouds";
import { JourneyScrim } from "../Decor/JourneyBand";
import Link from "../Link/Link";
import { surveyTypeLabel } from "./labels";
import styles from "./Index.module.css";

const LatestCardHero = ({ card }: { card: Card | null }) => {
  const t = useTranslations("dashboard");
  const d = useDateFormatter();
  const [showScreenshot, setShowScreenshot] = useState(false);

  return (
    <section className={styles.hero} aria-labelledby='latest-card-heading'>
      <Clouds preset='hero' />
      {card ? (
        <div className={styles.heroContent}>
          <div className={styles.heroText}>
            <JourneyScrim />
            <p className={styles.eyebrow}>{t("latestCard", t(surveyTypeLabel(card.surveyType)))}</p>
            <h2 id='latest-card-heading' className={styles.heroTitle}>
              {card.cardTitle || card.title}
            </h2>
            <p>
              {t(
                "cardSummary",
                card.surveyIds ? card.surveyIds.split(",").filter(Boolean).length : 0,
                // fromSurvey and toSurvey are survey ids; the period is the first and last response
                d(card.stats?.earliestResponse),
                d(card.stats?.latestResponse ?? card.latestResponse),
                card.responders,
                d(card.latestResponse),
              )}
            </p>
            <div className={styles.heroActions}>
              <button type='button' className={styles.primaryAction} onClick={() => setShowScreenshot(true)}>
                {t("downloadCard")}
              </button>
              <a className={styles.secondaryAction} href={getCardUrl(card.cardId)} target='_blank' rel='noreferrer'>
                {t("openLiveCard")}
              </a>
              <Link className={styles.secondaryAction} href='/card'>
                {t("createCard")}
              </Link>
            </div>
          </div>
          <div className={styles.heroCard}>
            <JourneyCard card={card} />
          </div>
        </div>
      ) : (
        <div className={styles.heroContent}>
          <div className={styles.heroText}>
            <JourneyScrim />
            <p className={styles.eyebrow}>{t("noCardEyebrow")}</p>
            <h2 id='latest-card-heading' className={styles.heroTitle}>
              {t("noCardTitle")}
            </h2>
            <p>{t("noCardBody")}</p>
            <div className={styles.heroActions}>
              <Link className={styles.primaryAction} href='/card'>
                {t("createFirstCard")}
              </Link>
            </div>
          </div>
        </div>
      )}
      {card && showScreenshot && (
        <Modal onClose={() => setShowScreenshot(false)}>
          <ScreenshotView card={card} />
        </Modal>
      )}
    </section>
  );
};

export default LatestCardHero;
